import { createType } from 'framework/utils/createType';

export const QuickFilters = createType('all', 'notPaid');
export type QuickFilter = typeof QuickFilters[number];
